module.exports = __webpack_public_path__ + "img/29_53.8d0bd15a.png";